import {
  LanguageSwitcherList
} from "./chunk-GC6KZBHF.mjs";

// src/LanguageSwitcher.tsx
import { VStack } from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var LanguageSwitcher = ({
  onItemClick,
  lists = [],
  activeItems
}) => /* @__PURE__ */ jsx(VStack, {
  spacing: 10,
  alignItems: "flex-start",
  children: lists && lists.map(({ listAutoflow, listHeading, listItems }) => /* @__PURE__ */ jsx(LanguageSwitcherList, {
    listHeading,
    listItems,
    listAutoflow,
    onItemClick,
    activeItems
  }, listHeading))
});

export {
  LanguageSwitcher
};
